import React from 'react'
import { Main } from '../AcademicCurriculum/AcademicCurriculum.element'
import { Directortext } from '../Codeofconduct/Code.element'
import { Directorbackground, Sub } from './Computer.element'

function Computerlab() {
    return (
        <Main>
                <Directorbackground>
                <Directortext>
                    <h1>Computer Lab</h1>
                    <p>The New Era Public School| <span>Computer Lab</span> </p>
                </Directortext>
      
            </Directorbackground> 

            <Sub>
                <p>
                There are 40 computers in the two labs along with the latest licence  versions of the educational and computing software required for the students. 
                </p>
            
            </Sub>
        </Main>
    )
}

export default Computerlab
